/** For use with react-dnd */
export var DraggableType;
(function (DraggableType) {
    /** Expects an `id` field to be provided */
    DraggableType["MEDIA_MANAGER_GALLECTION"] = "mm-gallection-grid";
    DraggableType["MEDIA_MANAGER_DEVIATION"] = "mm-deviation-grid";
    /** Expects a `deviation` field to be provided */
    DraggableType["DEVIATION"] = "deviation";
})(DraggableType || (DraggableType = {}));
// TODO: Figure out a decent way to type DND payloads
//# sourceMappingURL=dnd.js.map